import { render, staticRenderFns } from "./PayrollWorkspace.vue?vue&type=template&id=5a72df06&scoped=true&"
import script from "./PayrollWorkspace.vue?vue&type=script&lang=js&"
export * from "./PayrollWorkspace.vue?vue&type=script&lang=js&"
import style0 from "@/assets/rowHighlight.css?vue&type=style&index=0&lang=css&"
import style1 from "./payrollGlass.css?vue&type=style&index=1&lang=css&"
import style2 from "./PayrollWorkspace.vue?vue&type=style&index=2&id=5a72df06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a72df06",
  null
  
)

export default component.exports